module.exports = __webpack_public_path__ + "img/signs1_2.c37a24bc.jpg";